<template>
  <div class="lab_test__list">
    <div class="vx-card p-6">
      <!-- tab menu -->
      <vs-tabs>
        <vs-tab label="Pending">
          <div class="tab-text">
            <PendingLabTest />
          </div>
        </vs-tab>
        <vs-tab label="Complete">
          <div class="tab-text">
            <CompleteLabTest />
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import PendingLabTest from '@/views/lab-tests/components/PendingLabTest.vue'
import CompleteLabTest from '@/views/lab-tests/components/CompleteLabTest.vue'

export default {
  name: 'LabTestList',

  components: {
    PendingLabTest,
    CompleteLabTest
  }
}
</script>

<style>
</style>